import axios from "axios";
import StatsPreview from "../interfaces/StatsPreview";
import { BACKEND } from "../resources/constants/urls";
import {
  endPreviewSync,
  notifyPreviewMirrorSync,
  startPreviewSync,
  updatePreviewMirror,
} from "@appsinti/preview-mirror";
import auth from "../resources/api/auth";

const { Authorization } = auth;

const PREVIEW_TIMEOUT = 20000;

export const fetchAndStoreStatsPreview = async (
  appId: number,
  signal?: AbortSignal,
): Promise<void> => {
  if (!appId) return;
  startPreviewSync(appId);
  try {
    const { data } = await axios.get<StatsPreview>(
      `${BACKEND}/appsinti/stats/preview`,
      {
        headers: { "app-id": appId, Authorization },
        signal,
        timeout: PREVIEW_TIMEOUT,
      },
    );
    data.lastUpdate = new Date().getTime();
    updatePreviewMirror(JSON.stringify(data), appId);
    notifyPreviewMirrorSync();
  } catch (error) {
    if (!axios.isCancel(error)) console.error(error);
  } finally {
    endPreviewSync(appId);
  }
};
